import styled from '@emotion/styled'
import { COLORS } from 'parameters/index'

interface StyleProps {
	selected?: boolean
	clickable?: boolean
	executed?: boolean
}

export const CardWrapper = styled.div`
	display: flex;
	height: 100%;
	flex-grow: 1;
`

export const Card = styled.div<StyleProps>`
	display: flex;
	border-radius: 8px;
	box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.08);
	border: solid 1px
		${(props): string => (props.executed === false ? COLORS.KSU_PURPLE : props.selected ? '#833ec6' : 'white')};
	background-color: ${(props): string =>
		props.executed === false ? COLORS.LIGHT_PURPLE : props.selected ? '#f7f7ff' : 'white'};
	width: calc(100% - 80px);
	padding: 24px;
	margin-bottom: 32px;
	flex: 1;
	z-index: 1;
	cursor: ${(props): string => (props.clickable ? 'pointer' : 'default')};
	position: relative;
`
